import Svg, { Path } from "react-native-svg";

export const LogoutSidebarIcon = () => {
  return (
    <Svg width="22" height="22" viewBox="0 0 22 22" fill="none">
      <Path
        d="M16.5 18.0714V19.6428C16.5 20.0595 16.3344 20.4593 16.0397 20.7539C15.7451 21.0486 15.3454 21.2142 14.9286 21.2142H3.92858C3.5118 21.2142 3.11211 21.0486 2.8174 20.7539C2.52271 20.4593 2.35715 20.0595 2.35715 19.6428V2.35707C2.35715 1.9403 2.52271 1.54061 2.8174 1.2459C3.11211 0.951206 3.5118 0.785645 3.92858 0.785645H14.9286C15.3454 0.785645 15.7451 0.951206 16.0397 1.2459C16.3344 1.54061 16.5 1.9403 16.5 2.35707V3.9285"
        stroke="white"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.64285 11H19.6429"
        stroke="white"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 7.85718L19.6429 11L16.5 14.1429"
        stroke="white"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};
